var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{'is-expanded': _vm.is.expanded || _vm.expanded},on:{"mouseover":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }